import React from 'react';
import Dialog, { DialogProps } from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import useStyles from './styles';
import ConfirmationButtons from '../../components/ConfirmationButtons/ConfirmationButtons';

interface ConfirmDialogProps {
  title: string;
  handleOK: () => void;
  handleCancel: () => void;
  description?: string;
  loading?: boolean;
}

const ConfirmDialog = (props: ConfirmDialogProps & DialogProps) => {
  const { title, handleCancel, handleOK, description, loading } = props;
  const classes = useStyles();
  return (
    <div {...{ className: classes.title }}>
      <Dialog
        {...(props as DialogProps)}
        onClose={handleCancel}
        aria-labelledby="form-dialog-title"
        classes={{ paperWidthSm: classes.customWidth }}>
        <DialogTitle {...{ id: 'form-dialog-title', className: classes.title }}>
          {title}
        </DialogTitle>
        <DialogContent>
          {description && (
            <DialogContentText {...{ className: classes.content }}>
              {description}
            </DialogContentText>
          )}
        </DialogContent>

        <ConfirmationButtons
          containerStyle={{ padding: 25 }}
          handleCancel={handleCancel}
          handleConfirm={handleOK}
          disableConfirm={loading}
          disableCancel={loading}
        />
      </Dialog>
    </div>
  );
};

export default ConfirmDialog;
